<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="content">
  <mat-form-field class="param-full-width">
    <input
      matInput
      placeholder="Username"
      [(ngModel)]="username"
      (change)="handleCredentialChange()"
      />
  </mat-form-field>
  <mat-form-field class="param-full-width">
    <input
      matInput
      [type]="'password'"
      placeholder="Password"
      [(ngModel)]="password"
      (change)="handleCredentialChange()"
      />
  </mat-form-field>
</div>
<mat-expansion-panel [expanded]="true">
  @if (parent | async; as item) {
    <ng-container matExpansionPanelContent>
      <h3>VM Credential List</h3>
      <div class="scrolling-content flex-container">
        <div class="item-container">
          <div>
            <div id="wrapper">
              <div id="context">
                <button
                  mat-icon-button
                  (click)="addVmCredential()"
                  title="Add VM Credential"
                  >
                  <mat-icon fontIcon="mdi-plus-circle"></mat-icon>
                </button>
                Add VM Credential
              </div>
            </div>
          </div>
        </div>
        @for (vmCredential of vmCredentialList; track vmCredential) {
          <div class="item-container">
            <div>
              <div id="wrapper">
                <div id="context">
                  <button
                    mat-icon-button
                    (click)="selectVmCredential(vmCredential)"
                    title="Use {{ vmCredential.username }}"
                    >
                    <mat-icon fontIcon="mdi-play-circle-outline"></mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    (click)="deleteVmCredential(vmCredential)"
                    title="Delete {{ vmCredential.username }} from list"
                    >
                    <mat-icon fontIcon="mdi-trash-can-outline"></mat-icon>
                  </button>
                  @if (item.defaultVmCredentialId !== vmCredential.id) {
                    <button
                      mat-icon-button
                      (click)="setDefaultVmCredential(vmCredential.id, item)"
                      title="Set as Default"
                      >
                      <mat-icon fontIcon="mdi-checkbox-blank-outline"></mat-icon>
                    </button>
                  }
                  @if (item.defaultVmCredentialId === vmCredential.id) {
                    <button
                      mat-icon-button
                      (click)="setDefaultVmCredential(null, item)"
                      title="Unset Default"
                      >
                      <mat-icon fontIcon="mdi-checkbox-marked"></mat-icon>
                    </button>
                  }
                  <label title="{{ vmCredential.description }}">{{
                    vmCredential.username
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </ng-container>
  }
</mat-expansion-panel>
